import * as mutation from "./mutation-types";
import { stateMerge } from "vue-object-merge";
import { getBlankRecord } from "./helpers";
import { getInitialState, getUnloadedState } from "./state";

export const mutations = {
  [mutation.STATE_RESET](state) {
    stateMerge(state, getInitialState());
  },
  [mutation.STATE_UNLOAD](state) {
    stateMerge(state, getUnloadedState());
  },
  [mutation.STATE_UNLOAD_LISTING](state) {
    state.listing.loaded = false;
  },
  [mutation.STATE_HIDE_ERROR](state, hideArgument) {
    stateMerge(state[hideArgument], { error: { show: false } });
  },

  [mutation.LIST_SET_FILTERS](state, { levyCollectionId }) {
    state.listing.levyCollectionId = levyCollectionId;
  },
  [mutation.LIST_TOGGLE_EXPAND](state, index) {
    var newValue = !state.listing.expanded[index];
    state.listing.expanded.splice(index, 1, newValue);
  },
  [mutation.LIST_SET_PAGING](state, paging) {
    stateMerge(state.listing.paging, paging);
  },
  [mutation.LIST_SET_CRITERIA_DESCRIPTION](state, criteriaInfo) {
    state.listing.criteriaInfo = criteriaInfo;
  },
  [mutation.LIST_STARTED](state) {
    state.listing.loading = true;
  },
  [mutation.LIST_FAILED](state) {
    state.listing.loading = false;
  },
  [mutation.LIST_SUCCEEDED](state, records) {
    state.listing.loading = false;
    state.listing.loaded = true;
    state.listing.data = records;
    state.listing.expanded = new Array(records.length).fill(false);
  },

  [mutation.EDIT_SET_DATA](state, details) {
    stateMerge(state.edit.data, details);
    state.edit.error.show = false;
  },
  [mutation.EDIT_CLEAR](state) {
    state.edit.loading = false;
    state.edit.isNew = true;
    state.edit.data = getBlankRecord();
  },
  [mutation.EDIT_GET_STARTED](state) {
    state.edit.data = getBlankRecord();
    state.edit.loading = true;
    state.edit.isNew = false;
  },
  [mutation.EDIT_GET_FAILED](state) {
    state.edit.loading = false;
  },
  [mutation.EDIT_GET_SUCCEEDED](state, provider) {
    state.edit.loading = false;
    stateMerge(state.edit.data, provider);
  },

  [mutation.EDIT_SAVE_STARTED](state) {
    state.edit.saving = true;
    state.edit.error.show = false;
  },
  [mutation.EDIT_SAVE_FAILED](state, error) {
    state.edit.saving = false;
    state.edit.error.show = true;
    state.edit.error.details = error;
  },
  [mutation.EDIT_SAVE_SUCCEEDED](state) {
    state.edit.saving = false;
  },

  [mutation.EDIT_DELETE_STARTED](state) {
    state.delete.processing = true;
  },
  [mutation.EDIT_DELETE_FAILED](state) {
    state.delete.processing = false;
  },
  [mutation.EDIT_DELETE_SUCCEEDED](state) {
    state.delete.processing = false;
  },

  [mutation.GET_CANDIDATES_FOR_COPYING_STARTED](state, levyCollectionId) {
    state.candidatesForCopying.loading = true;
    state.candidatesForCopying.levyCollectionId = levyCollectionId;
  },
  [mutation.GET_CANDIDATES_FOR_COPYING_SUCCEEDED](state, candidates) {
    state.candidatesForCopying.loading = false;
    state.candidatesForCopying.loaded = true;
    state.candidatesForCopying.data = candidates;
  },
  [mutation.GET_CANDIDATES_FOR_COPYING_FAILED](state) {
    state.candidatesForCopying.loading = false;
    state.candidatesForCopying.loaded = false;
  },

  [mutation.GET_ALL_STARTED](state, levyCollectionId) {
    state.all.loading = true;
    state.all.levyCollectionId = levyCollectionId;
  },
  [mutation.GET_ALL_SUCCEEDED](state, data) {
    state.all.loading = false;
    state.all.loaded = true;
    state.all.data = data;
  },
  [mutation.GET_ALL_FAILED](state) {
    state.all.loading = false;
    state.all.loaded = false;
  },

  [mutation.COPY_STARTED](state) {
    state.copy.processing = true;
  },
  [mutation.COPY_SUCCEEDED](state) {
    state.copy.processing = false;
  },
  [mutation.COPY_FAILED](state) {
    state.copy.processing = false;
  },

  [mutation.EXPORT_STARTED](state) {
    state.listing.loading = true;
  },
  [mutation.EXPORT_FAILED](state) {
    state.listing.loading = false;
  },
  [mutation.EXPORT_SUCCEEDED](state) {
    state.listing.loading = false;
  }
};
